<!-- 
Table header for tables that don't have paging or searching.
-->
<template>
  <v-container fluid align-content-center class="paging-container pl-3 pr-2 pt-3 pb-0">
    <v-layout row wrap>
      <v-flex>
        <div class="our-table-header-text">
          {{ records }}
        </div>
      </v-flex>
      <v-spacer/>
      <v-flex class="text-xs-right">
        <table-icon-buttons
          :has-export="hasExport"
          :has-export-to-json="hasExportToJson"
          :has-expanders="hasExpanders"
          :expand-multiple="expandMultiple"
          @click="$emit('click:' + $event)"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import TableIconButtons from "./TableIconButtons.vue";

export default {
  components: { TableIconButtons },
  props: {
    totalItems: {
      type: Number,
      required: true
    },
    hasExport: {
      type: Boolean,
      default: false
    },
    hasExportToJson: {
      type: Boolean,
      default: false
    },
    hasExpanders: {
      type: Boolean,
      default: false
    },
    expandMultiple: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      menu: false
    };
  },
  computed: {
    records() {
      return this.totalItems ? `Showing ${this.totalItems} records.` : "";
    }
  }
};
</script>

<style lang="scss">
.our-table-header-text {
  cursor: default;
  display: inline-block;
  line-height: 28px;
  position: relative;
  top: 1px;
}
</style>